import api from "../../utils/API";

const getAllCompetencesSectoriellesForSelect = () => {
  return api.get(`/gestion/competencessectoriellesforselect/list`);
};
const getCompetencesSectoriellesDetails = (uuid) => {
  return api.get(`/gestion/competencessectorielles/${uuid}/details`);
};
export {getAllCompetencesSectoriellesForSelect, getCompetencesSectoriellesDetails};
